export const SET_STATE_USER = 'SET_STATE_USER';
export const SET_DEFAULT_USER = 'SET_DEFAULT_USER';
